exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#ingredient-input {\n  width: 40%;\n  height: 45px;\n  border-radius: 5px;\n  border: solid 1px lightgray; }\n\n#recipe-delete-btn {\n  background: transparent;\n  border: none;\n  color: #9b9b9b;\n  font-weight: 900;\n  font-size: 1.3em;\n  margin: 5px; }\n\n.ingredients {\n  display: flex;\n  justify-content: center;\n  align-items: center; }\n\n.fa-circle {\n  color: lightgray;\n  margin: 5px;\n  font-size: 1.5em; }\n\n.fa-times {\n  font-size: 1.5em;\n  margin: 5px; }\n", ""]);

// exports
